import { useQuery } from "@tanstack/react-query";
import { BusinessDetails } from "lib/features/auth/types";
import { User } from "lib/features/user/types";
import businessServices from "services/business-service";

export const getBusinessIdFn = async () => {
  try {
    const userData = localStorage.getItem("user") as string; // because it's a string in local storage
    const parsedUserObject = JSON.parse(userData) as User | undefined;

    const userId = parsedUserObject?.id;
    if (!userId) throw new Error("No user data found");

    const business = await businessServices.getUserBusiness(userId);

    return {
      businessId: business?.data?.data?.business?.[0]?.id,
    };
  } catch (error) {
    throw new Error("Error getting business id");
  }
};

export const getBusinessIdAsNumberFn = async () => {
  try {
    const userData = localStorage.getItem("user") as string; // because it's a string in local storage
    const parsedUserObject = JSON.parse(userData) as User | undefined;

    const userId = parsedUserObject?.id;
    if (!userId) throw new Error("No user data found");

    const business = await businessServices.getUserBusiness(userId);

    return business?.data[0]?.id;
  } catch (error) {
    throw new Error("Error getting business id");
  }
};

const getBusiessFn = async () => {
  try {
    const { businessId } = await getBusinessIdFn();
    if (!businessId) {
      throw new Error("No business id found");
    }
    const businessDetails = await businessServices.getBusinessDetail(
      businessId
    );

    return {
      business: businessDetails.data.data as BusinessDetails,
    };
  } catch (error) {
    throw new Error("Error getting business details");
  }
};

function useGetCurrentBusiness() {
  return useQuery({
    queryKey: ["get-current-business"],
    queryFn: getBusiessFn,
  });
}

export default useGetCurrentBusiness;
